import server from "../../../../server";


type GenerateOTP =
    | { type: "generate"; method: string }
    | { type: "regenerateOtp"; method: string }

export async function generateOtp(email: string) {
    await server.auth.sendOtp(email);
}

export async function verifyOtp(email: string, otp: string) {
    await server.auth.verifyOtp(email, otp);
}

export async function resetPassword(email: string, password: string, confirmPassword: string) {
    await server.auth.resetPassword({
        email: email,
        password: password,
        confirmPassword: confirmPassword,
    });
}
